import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'personal/';

export interface Personal {
    id: number;
    usuario: {
        id: number;
        first_name: string;
        last_name: string;
        email: string;
    } | null;
    cargo: string | null;
    telefono: string | null;
    fecha_creacion?: string;
    foto_url?: string | null;
    pin_caja_configurado?: boolean;
    /**
     * PIN vigente en claro. SOLO llega en el detalle (`fetchPersonalById`) a
     * un administrador; `null` cuando no hay PIN o es legado (solo hash).
     * Nunca aparece en el listado.
     */
    pin_caja_visible?: string | null;
}

export const fetchPersonal = async (): Promise<Personal[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<Personal[]>(API_URL);
        return response.data;
    });
};

export const fetchPersonalById = async (id: number): Promise<Personal> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<Personal>(`${API_URL}${id}/`);
        return response.data;
    });
};

export const createPersonal = async (data: {
    usuario?: number | null;
    cargo?: string | null;
    telefono?: string | null;
    pin_caja?: string;
}) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};
export const updatePersonal = async (
    id: number,
    data: {
        cargo?: string | null;
        telefono?: string | null;
        foto?: File | null;
        pin_caja?: string;
    }
) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        if (data.cargo !== undefined) formData.append('cargo', data.cargo ?? '');
        if (data.telefono !== undefined) formData.append('telefono', data.telefono ?? '');
        if (data.pin_caja !== undefined && data.pin_caja !== '') formData.append('pin_caja', data.pin_caja);
        if (data.foto) formData.append('foto', data.foto);

        const response = await axiosInstance.put(`${API_URL}${id}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    });
};

export const deletePersonal = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};

